/* 环境判断工具函数 */
import { loadJs } from './util'

/** 判断是不是开发环境 */
export function isDev() {
  return process.env.NODE_ENV === 'development'
}

/**  */
export function isServer() {
  return process.server
}

/* 判断是否是微信内置浏览器 */
export function isWeixin() {
  const ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  }
  return false
}
/* 判断是否是微信小程序环境 */
export function isMiniProgram() {
  const ua = window.navigator.userAgent.toLowerCase()
  return (
    isWeixin() &&
    (window.__wxjs_environment === 'miniprogram' ||
      ua.match(/miniprogram/i) === 'miniprogram')
  )
}
/* 判断是否在app中 */
export function isApp() {
  return (
    Object.prototype.hasOwnProperty.call(window, 'android') ||
    (Object.prototype.hasOwnProperty.call(window, 'webkit') &&
      Object.prototype.hasOwnProperty.call(
        window.webkit.messageHandlers,
        'iphone'
      ))
  )
}
/* 判断是否在wap中 */
export function isWap() {
  return !(isWeixin() || isMiniProgram() || isApp())
}
/**
 * 判断当前页面是否在android平台内
 * @return {bool}  如果是，返回true;否则返回false
 */
export function isAndroid() {
  return Object.prototype.hasOwnProperty.call(window, 'android')
}
/**
 * 判断当前页面是否在iOS平台内
 * @return {bool}  如果是，返回true;否则返回false
 */
export function isiOS() {
  return (
    Object.prototype.hasOwnProperty.call(window, 'webkit') &&
    Object.prototype.hasOwnProperty.call(
      window.webkit.messageHandlers,
      'iphone'
    )
  )
}

export function isPC() {
  return !/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
}

/**
 * 判断当前页面是否在华为浏览器平台内
 * @return {bool}  如果是，返回true;否则返回false
 */
export function isHuaWei() {
  return navigator.userAgent.toLowerCase().indexOf('huaweibrowser') > -1
}
export function isSamsung() {
  return navigator.userAgent.toLowerCase().indexOf('samsungbrowser') > -1
}
export function isVivo() {
  return navigator.userAgent.toLowerCase().indexOf('vivobrowser') > -1
}

/**
 * 判断当前页面是否在UC浏览器平台内
 * @return {bool}  如果是，返回true;否则返回false
 */
export function isUC() {
  return navigator.userAgent.toLowerCase().indexOf('ucbrowser') > -1
}

/* 判断是否是支付宝 */
export function isZhifubao() {
  return /alipay/i.test(navigator.userAgent)
}

/** 判断是否支付宝小程序 */
export function isAliApplet() {
  return new Promise(async resolve => {
    function getEnv() {
      return new Promise(resolve => {
        window.my.getEnv(res => {
          resolve(res)
        })
      })
    }
    try {
      if (!isZhifubao()) {
        return resolve(false)
      } else {
        await loadJs('//appx/web-view.min.js')
        const res = await getEnv()
        return resolve(res.miniprogram)
      }
    } catch (err) {
      return resolve(false)
    }
  })
}

/* 判断是否是快手小程序环境 */
export function isKuaiShouMiniProgram() {
  const ua = window.navigator.userAgent.toLowerCase()
  return /miniprogram/i.test(ua) && /kuaishou|KsWebView/i.test(ua)
}

/**
 * 判断是否在oppo浏览器内
 * @param {*} str
 */
export function isOppo() {
  return /heytapbrowser/i.test(navigator.userAgent)
}

/**
 * 判断当前页面是否是支付平台链接
 * @return {bool}  如果是，返回true;否则返回false
 */
export function isHref(str) {
  return str.indexOf('/payment/v1/tklifepay/mobile/page/pay.html') > -1
}
